import React, { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { X, Mail, MessageCircle } from 'lucide-react';

interface SupportContactModalProps {
  isOpen: boolean;
  onClose: () => void;
  role: 'user' | 'expert';
  name: string;
  code: string;
}

export const SupportContactModal: React.FC<SupportContactModalProps> = ({
  isOpen, onClose, role, name, code
}) => {
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  if (!isOpen) return null;

  const supportPhone = "918368832850"; 
  const supportEmail = "support@trueadviso.com"; 

  const messageText = `Hi i am ${role} in trueAdviso, My name is ${name} and my ${role} Code is ${code} , I HAVE A QUERY`;
  const encodedMessage = encodeURIComponent(messageText);
  const encodedSubject = encodeURIComponent(`Support Query from ${role.toUpperCase()} - ${name}`);

  // 🟢 Generate URLs beforehand for the <a> tags
  const whatsappUrl = `https://wa.me/${supportPhone}?text=${encodedMessage}`;
  const gmailUrl = `https://mail.google.com/mail/?view=cm&fs=1&to=${supportEmail}&su=${encodedSubject}&body=${encodedMessage}`;

  const modalContent = (
    <div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
      // 🟢 MAGIC FIX 1: Stop all mouse events from leaking out to the Navbar's "click outside" detector
      onMouseDown={(e) => e.stopPropagation()} 
      onClick={(e) => e.stopPropagation()}
    >
      {/* Invisible background overlay to close modal when clicking outside */}
      <div 
        className="absolute inset-0" 
        onMouseDown={(e) => { e.stopPropagation(); onClose(); }}
        onClick={(e) => { e.stopPropagation(); onClose(); }}
      ></div>
      
      <div 
        className="bg-white rounded-2xl shadow-2xl w-full max-w-sm overflow-hidden transform transition-all relative z-10"
        onMouseDown={(e) => e.stopPropagation()}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-gray-100 bg-gray-50">
          <h3 className="font-bold text-gray-800">Contact Support</h3>
          <button 
            onClick={onClose}
            className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-full transition-colors"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="p-6 space-y-4">
          <p className="text-sm text-gray-600 text-center mb-6">
            How would you like to contact our support team?
          </p>

          {/* 🟢 MAGIC FIX 2: Converted to an <a> tag. This bypasses ALL browser popup blockers! */}
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="w-full flex items-center justify-center gap-3 bg-[#25D366] hover:bg-[#128C7E] text-white py-3.5 rounded-xl font-bold transition-all active:scale-95 shadow-md shadow-green-500/20"
          >
            <MessageCircle className="w-5 h-5" />
            Continue to WhatsApp
          </a>

          {/* 🟢 Converted to an <a> tag here as well */}
          <a
            href={gmailUrl}
            target="_blank"
            rel="noopener noreferrer"
            onClick={onClose}
            className="w-full flex items-center justify-center gap-3 bg-red-500 hover:bg-red-600 text-white py-3.5 rounded-xl font-bold transition-all active:scale-95 shadow-md shadow-red-500/20"
          >
            <Mail className="w-5 h-5" />
            Send via Gmail
          </a>
        </div>
      </div>
    </div>
  );

  return createPortal(modalContent, document.body);
};